var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:_vm.classes,attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("icon"),_vm._v(" "),_c('small',{staticStyle:{"font-weight":"300"}},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }